import { useRef, useState } from 'react';
import { ColumnFiltersState } from '@tanstack/react-table';
import { SheetContent } from '@/components/ui/sheet';
import { StaffUnitHeader } from './StaffUnitHeader';
import { StaffUnitTable } from './StaffUnitTable';

interface schoolUnitProps {
  schoolList: { id: number; name: string }[] | undefined;
  actionDropdownRowId: string | null;
  setActionDropdownRowId: (id: string | null) => void;
}

export const StaffUnit = ({ schoolList, actionDropdownRowId, setActionDropdownRowId }: schoolUnitProps) => {
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const sheetRef = useRef<HTMLDivElement | null>(null);

  return (
    <SheetContent
      ref={sheetRef}
      className="flex !max-w-[1250px] flex-col items-start justify-start gap-y-10 border-l-0 bg-white p-0 focus-visible:outline-none"
      onInteractOutside={(event) => {
        // Check if the dropdown is open
        if (actionDropdownRowId !== null) {
          // prevent sheet from closing
          event.preventDefault();
        }
      }}
      onEscapeKeyDown={(e) => {
        e.preventDefault();
      }}
    >
      <StaffUnitHeader parentRef={sheetRef} schoolList={schoolList} setColumnFilters={setColumnFilters} />
      <StaffUnitTable
        parentRef={sheetRef}
        columnFilters={columnFilters}
        setColumnFilters={setColumnFilters}
        actionDropdownRowId={actionDropdownRowId}
        setActionDropdownRowId={setActionDropdownRowId}
      />
    </SheetContent>
  );
};
